import { Layout, UserPermissionProvider, getNavBar } from "@dgs/core";
import { ErrorBoundary } from "@sentry/react";
import { FC } from "react";
import { Outlet } from "react-router";
import { ApplicationBar } from "./ApplicationBar";
import { Footer } from "./Footer";
import { usePreviewMenuItems } from "./navigation/usePreviewMenuItems";
import { ErrorPage } from "./shared/ui/ErrorPage";

export const Content: FC = () => {
	return (
		<UserPermissionProvider>
			{(isInitialized) =>
				isInitialized && (
					<Layout
						navigation={null}
						header={
							<>
								<ApplicationBar />
								<Navigation />
							</>
						}
						content={
							<ErrorBoundary fallback={<ErrorPage />}>
								<Outlet />
							</ErrorBoundary>
						}
						footer={<Footer />}
					/>
				)
			}
		</UserPermissionProvider>
	);
};

const NavBar = getNavBar();

export const Navigation: FC = () => {
	const menuItems = usePreviewMenuItems("menu");

	return <NavBar items={menuItems} appIdentifier={<></>} />;
};
